// Action type for rehydrating RTK Query state
export const REHYDRATE_RTK_QUERY = 'persist/REHYDRATE_RTK_QUERY';
